import { useLocation } from "react-router"

import { usePaymentContext } from "modules/Payment/PaymentContext"
import { AfterFooter } from "components"
import {
    UserInfo,
    PaymentMethodsBlock,
    SessionInfoCard,
    SessionInfoMobileCard,
    NextPageButtonWithAdditionalInfoPay,
} from "modules/Payment/FormPage/components"

export function FormPage() {
    const [{ bookingDetails }] = usePaymentContext()
    const { key } = useLocation()

    return (
        <div className="redesign-container">
            <div className="booking-form-container">
                <div className="payment-and-contact-data-block">
                    <UserInfo
                        name={bookingDetails.client_name}
                        email={bookingDetails.client_email}
                        phone={bookingDetails.client_phone}
                    />
                    <PaymentMethodsBlock />
                    <SessionInfoMobileCard />
                </div>
                <SessionInfoCard />
            </div>
            <AfterFooter afterFooterKey={key}>
                <NextPageButtonWithAdditionalInfoPay />
            </AfterFooter>
        </div>
    )
}
